import { Loader2, Inbox } from "lucide-react";

export const Loading = ({ label = "Carregando..." }) => (
  <div className="flex flex-col items-center justify-center py-16 text-muted-foreground gap-3">
    <Loader2 className="w-6 h-6 animate-spin text-primary" />
    <p className="text-sm">{label}</p>
  </div>
);

export const EmptyState = ({ icon: Icon = Inbox, title = "Nada por aqui ainda", subtitle }) => (
  <div className="flex flex-col items-center justify-center py-16 text-center px-6">
    <div className="w-14 h-14 rounded-2xl glass flex items-center justify-center mb-4">
      <Icon className="w-6 h-6 text-primary" />
    </div>
    <p className="font-display font-semibold">{title}</p>
    {subtitle && <p className="text-sm text-muted-foreground mt-1 max-w-xs">{subtitle}</p>}
  </div>
);

export const Skeleton = ({ className = "" }) => (
  <div className={`animate-pulse rounded-2xl bg-white/5 ${className}`} />
);
